export enum KeywordActions {
  SET_KEYWORDS = "SET_KEYWORDS",
  SET_KEYWORD = "SET_KEYWORD",
  SET_LANDING_KEYWORD = "SET_LANDING_KEYWORD",
  ADD_KEYWORD = "ADD_KEYWORD",
  DELETE_KEYWORD = "DELETE_KEYWORD",
  UPDATE_KEYWORD = "UPDATE_KEYWORD",
};
